(function ($, window, undefined) {
    if (window.mg === undefined)
        window.mg = {};

    if (window.mg.ui === undefined)
        window.mg.ui = {};

    var _ = window.mg;

    function _popover($target, options) {
        var $container = $target.parents('.container'); // The nearest container ancestor
        var isMobile = mg.isMobile.any;

        var props = $.extend(true, {
            boundary: $container[0],
            container: $container,
            content: '',
            html: true, // Determines whether the content should be inserted as html or text
            sanitize: false,
            title: '',
            trigger: isMobile ? 'click' : 'hover'
        }, options);

        props.template = [
            '<div class="popover mg-popover" role="tooltip">',
                '<div class="arrow"></div>',
                '<div class="popover-body"></div>',
            '</div>'
        ].join('');

        var mainContent = props.content;
        props.content = [
            '<div class="popover-content">' + mainContent + '</div>',
            '<div class="popover-close" onclick="mg.ui.popover.close(this);">',
                '<span>' + mg.translations.Close + '</span>',
                '<i class="icon icon-close"></i>',
            '</div>'
        ].join('');

        $target.popover(props);
    }

    _.ui.popover = {
        create: function ($target, options) {
            _popover($target, options);
        },
        close: function (element) {
            $(element).parents('.mg-popover').popover('hide');
        }
    };

})(jQuery, window, undefined);
